/**
 * Utility for preloading images in the background
 */

export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!src) {
      resolve();
      return;
    }

    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    img.src = src;
  });
};

export const preloadImages = async (urls: string[]): Promise<void> => {
  const validUrls = urls.filter(url => url && url.trim() !== '');
  
  if (validUrls.length === 0) return;

  try {
    // Preload images in parallel with a limit to avoid overwhelming the browser
    const batchSize = 10;
    for (let i = 0; i < validUrls.length; i += batchSize) {
      const batch = validUrls.slice(i, i + batchSize);
      await Promise.allSettled(batch.map(url => preloadImage(url)));
    }
    console.log(`✅ Preloaded ${validUrls.length} images`);
  } catch (error) {
    console.warn('⚠️ Some images failed to preload:', error);
  }
};

export const preloadSchoolLogos = async (schools: Array<{ feedIcon?: string; resultsImage?: string }>): Promise<void> => {
  const logoUrls = schools
    .map(school => school.feedIcon || school.resultsImage)
    .filter((url): url is string => url !== undefined && url.trim() !== '');
  
  await preloadImages(logoUrls);
};
